export default {
  env: 'development',

  website: 'dashboard.metasense.com.au',
  apiServer: 'api.v2.metasense.com.au',
  // apiServer: '192.168.43.109:6001',
  staticServer: 'static.metasense.com.au',
  ssl: true
}
